import React, { FC, useEffect, useState } from "react";
import {
  Header3,
  Header4,
  IHeader3Props,
  ISocialLinks,
  logos,
} from "@trussle/external-components";
import classNames from "classnames";
import "./styles.scss";
import { swapChildrenTypeWithComponent } from "./swapChildrenTypeWithComponent";
import { PanelWrapper } from "../PanelWrapper";

export interface ITrussleHeaderProps extends IHeader3Props {
  betterV2?: boolean;
  navigationMenu: any;
  partner?: string;
  socialLinks?: ISocialLinks;
}

export const TrussleHeader: FC<ITrussleHeaderProps> = (props) => {
  const [isClient, setClient] = useState(false);

  useEffect(() => {
    setClient(true);
  }, []);

  const { navigationMenu, partner } = props;

  // As long as we have two heros, we need to make two sets of navigation menu items,
  // as one of the items is a hubspot form which requires a unique ID
  const globalMenuItemsWithChildrenComponents1 = navigationMenu
    ? swapChildrenTypeWithComponent(navigationMenu, "1")
    : navigationMenu;

  const header3Props = {
    ...props,
    navigationMenu,
    partner: partner && logos[partner] ? partner : undefined,
  };
  const key = isClient ? "client" : "server";

  return (
    <>
      {props.betterV2 ? (
        <>
          <div className="header4__padding-element" />
          <div className="header4__container">
            <PanelWrapper className="header-panel-wrapper" isBetterV2>
              <Header4
                homeUrl={props.homeUrl}
                isLoggedIn={props.isLoggedIn}
                isLoading={props.isLoading}
                partner={header3Props.partner}
                socialLinks={props.socialLinks}
                signInButtonOptions={props.signInButtonOptions}
                onLogInButtonClick={props.onLogInButtonClick}
                navigationMenuItems={navigationMenu}
              />
            </PanelWrapper>
          </div>
        </>
      ) : (
        <div
          className={classNames("header3__container", "regular", {
            header3__container_partner: partner && logos[partner],
          })}
        >
          <Header3
            // Requires this key as  header3__container_partner doesn't get applied otherwise
            key={key}
            {...header3Props}
            navigationMenu={globalMenuItemsWithChildrenComponents1}
            theme="light"
            classOverrides={{ header3: classNames("header3__inner") }}
          />
        </div>
      )}
    </>
  );
};
